export default {
  fromNumber: (n, d) =>
    n.toFixed(d).replace(/./g, function (c, i, a) {
      return i && c !== '.' && (d === 0 || i < a.indexOf('.')) && (a.length - i) % 3 === 0
        ? ',' + c
        : c;
    })
};



// WEBPACK FOOTER //
// ./src/modules/currency.js